<template>
  <div id="contenedor-card-estadistica">
    <v-card
      outlined
      flat
      :color="color"
      :dark="dark">
      <v-card-title
        class="text-truncate d-block">
        {{ titulo }}
      </v-card-title>
      <v-card-text
        class="mt-4">
        <div class="d-flex align-center">
          <h1
            class="text-md-h2 text-sm-h5 text-xl-h1 font-weight-medium"
            :class="colorEstadistica">
            {{ estadistica }}
          </h1>
          <div class="d-flex align-center ml-2">
            <slot
              name="estadistica-icono">
            </slot>
          </div>
        </div>
        <h4 class="mt-2 font-weight-medium">
          <slot
            name="subtitulo">
          </slot>
        </h4>
      </v-card-text>
      <slot
        name="footer">
      </slot>
      <slot
        name="mas-estadisticas">
      </slot>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'estadisticaCard',
  props: {
    estadistica: {
    },
    titulo: {
      type: String,
    },
    color: {
      type: String,
    },
    dark: {
      type: Boolean,
    },
    colorEstadistica: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
